import { ToastData } from "@/@types";
import mitt, { Emitter } from "mitt";

export enum EventBusNames {
  SHOW_TOAST = "SHOW_TOAST",
  CLEAR_IMAGE_CROPPER = "CLEAR_IMAGE_CROPPER",
  UPDATE_HOME_GENERAL = "UPDATE_HOME_GENERAL",
  UPDATE_SESSION_DETAIL = "UPDATE_SESSION_DETAIL",
}

export type Events = {
  [EventBusNames.SHOW_TOAST]: ToastData;
  [EventBusNames.CLEAR_IMAGE_CROPPER]: void;
  [EventBusNames.UPDATE_SESSION_DETAIL]: void;
};

const emitter: Emitter<Events> = mitt<Events>();

export const EventBus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
};
